module.exports = __webpack_public_path__ + "img/buycar.4f4b640e.png";